import React from "react";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { ExternalLink, Globe } from "lucide-react";
import type { CitationSource } from "@/lib/chat/citations";

interface CitationBadgeProps {
  index: number;
  source: CitationSource;
}

export const CitationBadge: React.FC<CitationBadgeProps> = ({ index, source }) => {
  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <a
          href={source.url}
          target="_blank"
          rel="noopener noreferrer"
          className="
            inline-flex items-center justify-center
            mx-0.5 align-super
            min-w-[1.1rem] h-[1.1rem]
            rounded-full
            bg-primary/10 hover:bg-primary/20
            text-[0.65rem] font-semibold text-primary
            no-underline cursor-pointer
            transition-colors duration-150
            leading-none
            px-1
          "
          onClick={(e) => e.stopPropagation()}
        >
          {index}
        </a>
      </HoverCardTrigger>
      <HoverCardContent
        side="top"
        align="center"
        className="w-72 p-0 overflow-hidden"
        sideOffset={4}
      >
        <a
          href={source.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block no-underline"
        >
          <div className="p-3 space-y-2">
            {/* Title */}
            <p className="text-sm font-medium text-foreground line-clamp-2 leading-snug">
              {source.title || source.hostname}
            </p>

            {/* URL row */}
            <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
              <Globe className="h-3 w-3 flex-shrink-0" />
              <span className="truncate">{source.hostname}</span>
              <ExternalLink className="h-3 w-3 flex-shrink-0 ml-auto" />
            </div>
          </div>
        </a>
      </HoverCardContent>
    </HoverCard>
  );
};
